import { render, staticRenderFns } from "./SaveDialog.vue?vue&type=template&id=afb7d458&scoped=true"
import script from "./SaveDialog.vue?vue&type=script&lang=js"
export * from "./SaveDialog.vue?vue&type=script&lang=js"
import style0 from "./SaveDialog.vue?vue&type=style&index=0&id=afb7d458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb7d458",
  null
  
)

export default component.exports